import Handler from "../Handler";

class BetLockedHandler extends Handler {
  execute(message) {
    this.service.processBetLock();
  }
}

export default BetLockedHandler;
